import styled from "styled-components";

export const HomeSection = styled.section.attrs(props => ({
    id: props.id,
}))`
    width: 100%;
    min-height: 100vh;
    position: relative;
    
    & .full-screen {
        padding: 5rem 0;
        min-height: 100vh;
    }

    & .greetings,
    & .welcome-img {
        flex: 0 0 50%;
        max-width: 50%;
        padding: 0 1.5rem;

        @media screen and (max-width:1000px) {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }

    & .greetings {
        @media screen and (max-width:1000px) {
            text-align: center;
            margin-top: -10rem;
        }

        @media screen and (max-width:500px) {
            margin-top: 5rem;
        }

        & p {
            color: var(--color-text);
            font-size: 2rem;
            text-transform: capitalize;
            margin: 0;

            &.work {
                font-size: 2.2rem;
                font-weight: 500;
            }
        }

        & h2 {
            color: var(--color-primary-dark);
            font-size: 6rem;
            font-weight: 700;
            margin: 0;
        }

        & .btn-link {
            margin-top: 30px;

            & span {
                font-weight: 700;
            }
        }
    }

    & .welcome-img {
        @media screen and (max-width:1000px) {
            order: -1;
        }
    }

    & .welcome-img .img-box {
        max-width: 45rem;
        display: block;
        margin: auto;
        border-radius: 50%;
        padding: 1.5rem;

        @media screen and (max-width:1000px) {
            max-width: 50rem;
        }

        @media screen and (max-width:500px) {
            max-width: 45rem;
        }


        & img {
            width: 100%;
            border-radius: 50%;
            border: 1rem solid transparent;
        }
    }
`;